<template>
    <div class="user-profile">
        <transition-group
            name="fade"
            mode="out-in"
        >
            <base-loader
                v-if="isLoading"
                key="loader"
            />
            <template v-else-if="controls.length > 0">
                <info-box
                    :key="'info-box-personal'"
                    :controls="[
                        controls[0],
                        controls[1],
                    ]"
                    :all-controls="controls"
                    :user-meta="userMeta"
                    :error="hasError"
                >
                    <template v-slot:title>
                        Personal Info
                    </template>
                </info-box>
                <info-box
                    :key="'info-box-podcast'"
                    :controls="[
                        controls[3],
                        controls[4],
                        controls[5],
                        controls[6],
                        controls[7],
                        controls[8],
                    ]"
                    :all-controls="controls"
                    :user-meta="userMeta"
                    :error="hasError"
                >
                    <template v-slot:title>
                        Podcast Info
                    </template>
                </info-box>
            </template>
        </transition-group>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { map, get, zipObject } from 'lodash';

import InfoBox from '@/components/Dashboard/Settings/InfoBox.vue';

export default {
    components: {
        InfoBox,
    },

    computed: {
        ...mapState({
            controls: 'profileControls',
            isLoading: state => null === state.profileControls,
            hasError: state => false === state.profileControls,
            userMeta: state => zipObject(
                map(state.profileControls, 'name'),
                map(state.profileControls, ({ name }) => get(state.user.meta_data, name, ''))
            ),
        }),
    },

    /**
     * Created hook
     */
    created() {
        this.$event.$on(
            'update-anwser',
            ({ control, answer }) => this.$set(this.userMeta, control, answer)
        );
    },

    /**
     * Deregister event listener
     */
    beforeDestroy() {
        this.$event.$off('update-anwser');
    },
};

</script>
